export interface SaasSupportRoutingsProps {
    companyName: string;
}
export default function SaasSupportWarningPage({ companyName }: SaasSupportRoutingsProps) {
    return (
        <div className="silverfortSupportWarningBanner">
            <span className="silverfortSupportWarningBannerBold">Attention! </span> This is a live production
            environment of
            <span className="silverfortSupportWarningBannerBold">{companyName}</span>
        </div>
    );
}
